import React from 'react';
import BaseSelector, { Option } from '@components/selectors/BaseSelector';
import { AgileMacroplanogram } from '@components/agile/types/AgileMacroplanogramTypes';

interface MacroplanogramSelectorProps {
  value?: string;
  onChange: (macroplanogramId: string) => void;
  macroplanogramList: AgileMacroplanogram[] | null | undefined;
  disabled?: boolean;
}

/**
 * Macroplanogram selector dropdown.
 * Accepts a pre-fetched list of macroplanograms from the parent.
 */
const MacroplanogramSelector: React.FC<MacroplanogramSelectorProps> = ({
  value,
  onChange,
  macroplanogramList,
  disabled = false,
}) => {
  const options: Option[] = macroplanogramList
    ? macroplanogramList.map((mp) => ({
        value: mp.entryId,
        label: mp.macroplanogramName || mp.entryId,
      }))
    : [];

  return (
    <BaseSelector<Option>
      label="Macroplanogram"
      placeholder={disabled ? 'Select store & date first' : 'Select a macroplanogram'}
      options={options}
      value={value}
      onChange={onChange}
      disabled={disabled}
    />
  );
};

export default MacroplanogramSelector;
